import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
} from '@mui/material';

const Privacy = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        py: 4,
      }}
    >
      <Container component="main" maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            padding: 4,
            backgroundColor: '#ffffff',
          }}
        >
          <Typography
            component="h1"
            variant="h4"
            sx={{
              fontWeight: 'bold',
              color: '#000000',
              marginBottom: 3,
            }}
          >
            개인정보 수집 및 이용 동의
          </Typography>

          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                color: '#000000',
                marginBottom: 2,
                marginTop: 3,
              }}
            >
              1. 개인정보의 수집 및 이용 목적
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#666666',
                whiteSpace: 'pre-line',
                lineHeight: 1.8,
                marginBottom: 3,
              }}
            >
              {`planGo (이하 "회사"라 함)은 다음의 목적을 위하여 개인정보를 수집·이용하는 것에 대해 명확히 이해하였으며, 이에 동의합니다.
개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.

① 개인정보 수집·이용 목적
- 회원가입 및 서비스 제공
- 회원 가입 및 본인 식별·인증
- 주문 실행 보조
- 계좌 정보 연동
- 관심종목 관리 및 거래 내역 조회

② 회원 관리
- 회원자격 유지·관리, 제한적 본인확인제 시행에 따른 본인확인
- 불만처리 등 민원처리, 고지사항 전달

③ 서비스 개선 및 신규 서비스 개발
- 서비스 이용에 대한 통계 분석
- 신규 서비스 개발 및 맞춤 서비스 제공
- 서비스 품질 향상을 위한 설문조사 및 고객 만족도 조사`}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                color: '#000000',
                marginBottom: 2,
                marginTop: 3,
              }}
            >
              2. 수집하는 개인정보의 항목
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#666666',
                whiteSpace: 'pre-line',
                lineHeight: 1.8,
                marginBottom: 3,
              }}
            >
              {`회사는 회원가입, 서비스 이용 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.

① 회원가입 시
- 필수항목: 이메일, 사용자명, 비밀번호, 휴대폰 번호
- 선택항목: 없음

② 서비스 이용 과정에서 자동 수집되는 정보
- IP주소, 쿠키, 서비스 이용 기록, 방문 기록, 접속로그 기록 등

③ 키움증권 계좌 연동 시
- 키움증권 App Key, App Secret, Access Token
- 계좌번호, 계좌 잔고 정보, 보유 종목 정보
- 거래 내역 정보
※ 위 정보는 주문 실행 및 계좌 조회 목적에 한하여 사용되며,
※ Access Token 및 인증정보는 암호화하여 저장됩니다.`}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                color: '#000000',
                marginBottom: 2,
                marginTop: 3,
              }}
            >
              3. 개인정보의 보유 및 이용 기간
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#666666',
                whiteSpace: 'pre-line',
                lineHeight: 1.8,
                marginBottom: 3,
              }}
            >
              {`① 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.

② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
- 회원 가입 및 관리: 회원 탈퇴 시까지 (단, 관계 법령 위반에 따른 수사·조사 등이 진행중인 경우에는 해당 수사·조사 종료 시까지)
- 증권사 계좌 연동 정보: 연동 해지 시 즉시 삭제
- Access Token: 유효기간 만료 또는 로그아웃 시 파기
- 재화 또는 서비스 제공: 재화·서비스 공급완료 및 요금결제·정산 완료 시까지
- 전자상거래에서의 계약·청약철회, 대금결제, 재화 등 공급기록: 5년
- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년
- 웹사이트 방문기록: 3개월`}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                color: '#000000',
                marginBottom: 2,
                marginTop: 3,
              }}
            >
              4. 개인정보의 제3자 제공
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#666666',
                whiteSpace: 'pre-line',
                lineHeight: 1.8,
                marginBottom: 3,
              }}
            >
              {`① 회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.

② 회사는 원칙적으로 정보주체의 개인정보를 외국에 제공하지 않습니다. 다만, 정보주체의 동의를 받은 경우 또는 법령에 따라 제공이 필요한 경우에는 예외로 합니다.`}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                color: '#000000',
                marginBottom: 2,
                marginTop: 3,
              }}
            >
              5. 정보주체의 권리·의무 및 행사방법
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#666666',
                whiteSpace: 'pre-line',
                lineHeight: 1.8,
                marginBottom: 3,
              }}
            >
              {`① 정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
- 개인정보 처리정지 요구
- 개인정보 열람 요구
- 개인정보 정정·삭제 요구
- 개인정보 처리정지 요구

② 제1항에 따른 권리 행사는 회사에 대해 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.

③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.`}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                color: '#000000',
                marginBottom: 2,
                marginTop: 3,
              }}
            >
              6. 개인정보의 파기
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#666666',
                whiteSpace: 'pre-line',
                lineHeight: 1.8,
                marginBottom: 3,
              }}
            >
              {`① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.

② 개인정보 파기의 절차 및 방법은 다음과 같습니다.
- 파기절차: 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
- 파기방법: 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.`}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                color: '#000000',
                marginBottom: 2,
                marginTop: 3,
              }}
            >
              7. 개인정보 보호책임자
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#666666',
                whiteSpace: 'pre-line',
                lineHeight: 1.8,
                marginBottom: 3,
              }}
            >
              {`① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.

▶ 개인정보 보호책임자
- 성명: planGo 관리자
- 연락처: support@plango.today

② 정보주체께서는 회사의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의하실 수 있습니다.`}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                color: '#000000',
                marginBottom: 2,
                marginTop: 3,
              }}
            >
              8. 개인정보의 안전성 확보 조치
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#666666',
                whiteSpace: 'pre-line',
                lineHeight: 1.8,
                marginBottom: 3,
              }}
            >
              {`회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
- 관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육 등
- 기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치
- 물리적 조치: 전산실, 자료보관실 등의 접근통제`}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                color: '#000000',
                marginBottom: 2,
                marginTop: 3,
              }}
            >
              9. 개인정보 처리방침 변경
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#666666',
                whiteSpace: 'pre-line',
                lineHeight: 1.8,
                marginBottom: 3,
              }}
            >
              {`이 개인정보 처리방침은 2025년 12월 21일부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.`}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
            <Button
              variant="contained"
              onClick={() => window.close()}
              sx={{
                backgroundColor: '#000000',
                color: '#ffffff',
                '&:hover': {
                  backgroundColor: '#333333',
                },
              }}
            >
              닫기
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Privacy;

